/**
 * Created by fan on 3/13/17.
 */
angular.module('smartorg.r6.cmpts.tableSelector', []);
require('./table-selector-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.cmpts.tableSelector';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/components/table-selector/app/js/plumbing/app.js